module.exports = __webpack_public_path__ + "static/img/zhongzhongka2.39e110b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka2.png
// module id = HFMs
// module chunks = 16